//useCurrentJob.js

import {useEffect, useState} from "react";

const STORAGE_KEY = "custor.currentJob";


export function useCurrentJob() {

    const [jobId,setJobId] = useState(
        () => localStorage.getItem(STORAGE_KEY)
    );


    const setCurrentJob = (id) => {

        if(id){
            localStorage.setItem(
                STORAGE_KEY,
                id
            );
        } else {
            localStorage.removeItem(
                STORAGE_KEY
            );
        }

        setJobId(id);
    };


    const clearJob = () => {

        localStorage.removeItem(
            STORAGE_KEY
        );

        setJobId(null);
    };


    useEffect(()=>{

        const handler = () => {

            setJobId(
                localStorage.getItem(
                    STORAGE_KEY
                )
            );
        };


        window.addEventListener(
            "storage",
            handler
        );


        return ()=>{

            window.removeEventListener(
                "storage",
                handler
            );

        };

    },[]);


    return {
        jobId,
        setCurrentJob,
        clearJob
    };
}